import React, { useState } from "react";
import uklogo from "../../assets/kangaroo/uk_logo-cropped.svg";
import { Col, Row } from "reactstrap";
import button from "../../assets/kangaroo/button-cropped.svg";
import { useNavigate } from "react-router-dom";
import MultiStepForm from "../../component/MultiStepForm/MultiForm";
import { ArrowButton } from "../../component/button/ArrowButton";

const Gcomponent = ({ isMobile, data }) => {
  const router = useNavigate()
  const [modal, setModal] = useState(false);
  const toggleModal = () => setModal(prev => !prev);

  return (
    <React.Fragment>
      {!isMobile ? (
        <svg
          id="Layer_1"
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 448.37 516.06"
          style={{ width: "57%", height: "auto", }}
        >

        

          <g transform="translate(0,-30)" style={{ cursor: "pointer" }} onClick={toggleModal}>
  {/* Transparent rectangle covering the whole clickable area */}
  <rect
    x={30}        // adjust to cover entire group area
    y={450}       // adjust to cover entire group area
    width={250}   // adjust width to cover entire group area
    height={80}   // adjust height to cover entire group area
    fill="transparent"
  />

  <text
    transform="translate(77.02 488.38)"
    style={{
      fill: data?.[0]?.buttonColor,
      fontFamily: "Proxima Nova Bold, 'Proxima Nova'",
      fontSize: 18.83,
      fontWeight: 700,
    }}
  >
    {data?.[0]?.buttonText?.split("/n").map((line, index) => (
      <tspan
        key={index}
        x="0"
        y={index === 0 ? "-10" : 18.83 * index - 10}
      >
        {line}
      </tspan>
    ))}
  </text>

  <path
    d="M244.8,446.86H38.51c-17.62,0-32.12,13.31-34.01,30.42h42.49l-12.33-12.33c-1.49-1.49-1.49-3.9,0-5.39,1.49-1.49,3.9-1.49,5.39,0l18.75,18.75c.77.77,1.13,1.78,1.11,2.79.02,1.01-.34,2.02-1.11,2.79l-18.75,18.75c-1.49,1.49-3.9,1.49-5.39,0-1.49-1.49-1.49-3.9,0-5.39l12.33-12.33H4.5c1.9,17.11,16.4,30.42,34.01,30.42h206.29c18.9,0,34.23-15.32,34.23-34.23h0c0-18.9-15.32-34.23-34.23-34.23Z"
    fill="none"
    stroke={data?.[0]?.buttonColor}
    strokeWidth={1.5}
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</g>


          {/* Main Heading */}


          <foreignObject
            x="0.94"
            y="160.76"
            width="500"    // set your desired fixed width
            height="200"   // set enough height for all lines
          >
            <div
              xmlns="http://www.w3.org/1999/xhtml"
              style={{
                fontFamily: "Proxima Nova Black, Proxima Nova",
                fontSize: "52px",
                fontWeight: 800,
                color: data?.[0]?.titleColor,
                lineHeight: "1",
                wordWrap: "break-word",
              }}
            >

              {data?.[0]?.title?.split("/n").map((line, index) => (
                <React.Fragment key={index}>
                  {line}
                  <br />
                </React.Fragment>
              ))}



            </div>
          </foreignObject>

          {/* Subheading */}

          <foreignObject
            x="1.94"
            y="324.3"
            width="500"
            height="100"
          >
            <div
              xmlns="http://www.w3.org/1999/xhtml"
              style={{
                fontFamily: "Proxima Nova Regular, Proxima Nova",
                fontSize: "22px",
                color: "black",
                lineHeight: "1.1",
                wordWrap: "break-word",
                width: "90%",
              }}
            >
              {data?.[0]?.subTitle?.split("/n").map((line, index) => (
                <React.Fragment key={index}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </div>
          </foreignObject>





        </svg>) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 668.9 170.47"
          width="100%"
        >
          {/* Description text */}


          <foreignObject
            x="0"
            y="95.61"
            width="350"
            height="120"
          >
            <div
              xmlns="http://www.w3.org/1999/xhtml"
              style={{
                fontFamily: "Proxima Nova Regular",
                fontSize: "22px",
                color: "black",
                lineHeight: "1.1",
                wordWrap: "break-word",
              }}
            >
              {data?.[0]?.subTitle?.split("/n").map((line, index) => (
                <div key={index} style={{ lineHeight: "1.05" }}>
                  {line}
                </div>
              ))}
            </div>
          </foreignObject>

          {/* Heading */}


          <foreignObject
            x="220.94"
            y="1.67"        // match the y from your <text> transform
            width="500"      // set your desired width
            height="200"     // enough height for all lines
          >
            <div
              xmlns="http://www.w3.org/1999/xhtml"
              style={{
                fontFamily: "Proxima Nova Black, Proxima Nova",
                fontSize: "39px",        // match your <text> font size
                fontWeight: 800,
                color: data?.[0]?.titleColor,
                lineHeight: "1.05",      // adjust line spacing
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                margin: 0,
                padding: 0,
              }}
            >
              {data?.[0]?.title?.split("/n")}
            </div>
          </foreignObject>

          {/* CTA Group */}
          <g onClick={toggleModal}>
            <text
              transform="translate(459.24 142.78)"
              style={{
                fontFamily: "Proxima Nova ",
                fontSize: "18.83px",
                fontWeight: 700,
                fill: data?.[0]?.buttonColor,
                cursor: "pointer",
              }}
            >
              {data?.[0]?.buttonText?.split("/n").map((line, index) => (
                <tspan key={index} x="0" y={index === 0 ? "-10" : 18.83 * index - 10}>
                  {line}
                </tspan>
              ))}
            </text>

            {/* Outline button */}
            <path
              d="M627.02,101.26h-206.29c-17.62,0-32.12,13.31-34.01,30.42h42.49l-12.33-12.33c-1.49-1.49-1.49-3.9,0-5.39,1.49-1.49,3.9-1.49,5.39,0l18.75,18.75c.77.77,1.13,1.78,1.11,2.79.02,1.01-.34,2.02-1.11,2.79l-18.75,18.75c-1.49,1.49-3.9,1.49-5.39,0-1.49-1.49-1.49-3.9,0-5.39l12.33-12.33h-42.49c1.9,17.11,16.4,30.42,34.01,30.42h206.29c18.9,0,34.23-15.32,34.23-34.23s-15.32-34.23-34.23-34.23Z"
              style={{
                fill: "none",
                stroke: data?.[0]?.buttonColor,
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }}
            />
          </g>
        </svg>)}
      <MultiStepForm isOpen={modal} toggleModal={toggleModal} formOrigin={1} />
    </React.Fragment>
  );
};

export default Gcomponent;
